import { render, staticRenderFns } from "./wordSearchDetail.vue?vue&type=template&id=063d9020&scoped=true"
import script from "./wordSearchDetail.vue?vue&type=script&lang=js"
export * from "./wordSearchDetail.vue?vue&type=script&lang=js"
import style0 from "./wordSearchDetail.vue?vue&type=style&index=0&id=063d9020&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d9020",
  null
  
)

export default component.exports